import { BONUS_CAMPAIGN_TYPE } from '../../../constants/enums';
import CampaignBonusReportsPage, { type CampaignBonusReportsPageProps } from './CampaignBonusReportsPage';

type NumberOfSelectionsBonusReportsPageProps = Omit<CampaignBonusReportsPageProps, 'bonusType'>;

const NumberOfSelectionsBonusReportsPage = (props: NumberOfSelectionsBonusReportsPageProps) => {
  return <CampaignBonusReportsPage {...props} bonusType={BONUS_CAMPAIGN_TYPE.NUM_OF_SELECTIONS} />;
};

export default NumberOfSelectionsBonusReportsPage;
